require("./main.less");
document.addEventListener("DOMContentLoaded", function(event) {
    //do work
    let $toggler=document.querySelector("#pxv-nav .toggler");
    console.log($toggler);
    $toggler.addEventListener("click",function(){
        document.querySelector("#pxv-nav").classList.toggle("open");
    })
});


// WEBPACK FOOTER //
// ./src/main.js